import { Main } from 'components/Main';
import Page from 'components/Page';
import * as React from 'react';
import { Spinner } from 'components/Spinner';
const AdminAddStatePage = React.lazy(() => import(/* webpackChunkName: "AdminAddState" */ './Page'));
export const AdminAddState = () => (React.createElement(Page, { title: "Administrator Add State" },
    React.createElement(Main, { sidebar: true },
        React.createElement(React.Suspense, { fallback: React.createElement(Spinner, { full: true }) },
            React.createElement(AdminAddStatePage, null)))));
